export default __webpack_public_path__ + "2c92136015cd0278d6886dcdd09125e6.png";